import { render, staticRenderFns } from "./DtdMatchPlugin.vue?vue&type=template&id=ff94a7c4"
import script from "./DtdMatchPlugin.vue?vue&type=script&lang=js"
export * from "./DtdMatchPlugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports